(function () {
    angular.module('tmx-app').controller('privateCtrl', ['$state','routes','$scope', '$filter', 'resolvedData', 'tmxUtility', 'menu','TmxDialogService', 'PrevilegeService','UsersService',
        function PrivateCtrl($state,routes,$scope, $filter, resolvedData, tmxUtility, menu,TmxDialogService,PrevilegeService,UsersService) {
            var vm = this;
            vm.Configurations = resolvedData.Configurations;

            vm.menu=menu;                                
            var idleTimeout = null;
            var idleTimeoutMins = 0;
            vm.copySubPagetoMainObj = copySubPagetoMainObj;
            var exists=tmxUtility.exists;
            var checkPrevileges=PrevilegeService.CheckStatePrevilege;                        

            function CheckPrevileges(){                         
                angular.forEach(menu.pages.sections , function(sections){ 
                    sections.visibility=true;                                                                                                     
                    if (exists(sections.pages)) {                           
                        var countPagesInSection = 0;     
                        angular.forEach(sections.pages , function(page){  
                            page.visibility=true;                                 
                            if (exists(page.route)) {                                          
                                if (!checkPrevileges("private."+page.route)){
                                    countPagesInSection++;                        
                                    page.visibility=false;
                                }                      
                            }                                                                                                                                    
                        }); 
                        if(sections.pages.length==countPagesInSection){
                            sections.visibility=false;
                        } 
                    }                                                        
                    else  if(angular.isDefined(sections.route)){
                        if(!checkPrevileges("private."+sections.route)){
                            sections.visibility=false;
                        } 
                    }
                });                            
            }

            function copySubPagetoMainObj(){
                angular.forEach(vm.PageSectionsCopy , function(toggle){
                    if(angular.isDefined(toggle.pages)){
                        angular.forEach(toggle.pages , function(page){
                            if(angular.isDefined(page.pages)){
                                angular.forEach(page.pages , function(subpage){
                                    toggle.pages.push(subpage);
                                });
                            }
                        });
                    }
                });
            }
            vm.copySubPagetoMainObj(); // copy sub pages into pages

            (function InitializePage() {                
                idleTimeoutMins = Number(tmxUtility.getConfigurationValue(vm.Configurations, "PORTAL_IDLE_TIMEOUT_MINS"));
                initializeTimer();
                CheckPrevileges();
                UsersService.getBranchesLov();
                vm.PageSectionsCopy =  angular.copy(vm.menu.pages.sections);   // deep copy
            })();


                //#region -------Private functions===========
            function onInactive(millisecond, callback) {

                idleTimeout = setTimeout(callback, millisecond);
                document.onmousemove =
                                document.onclick =
                                document.onkeydown = function () {
                                    clearTimeout(idleTimeout);
                                    idleTimeout = setTimeout(callback, millisecond);
                                };
            }
            function initializeTimer() {                
                if (!isNaN(idleTimeoutMins) && idleTimeoutMins > 0) {
                    onInactive(Number(idleTimeoutMins * 60 * 1000), function () {
                        var message = $filter('translate')("IdleSessionTimeout");
                        TmxDialogService.showAlertDialog('Alert', message, menu.LogoutUser);
                    });
                }
            }

                //#endregion

            $scope.changeHoverIndex = function($index, $event) {                    
                $scope.hoveredIndex = $index;                    
        
                setTimeout(function(){
                    var childMenuHeight = $event.clientY + $('.extend-menu').not('.ng-hide')[0].scrollHeight;
                    var windowHeight = $(window).height();
                    var actualTopSize = childMenuHeight - windowHeight;
        
                    if(childMenuHeight > windowHeight){
                        $('.extend-menu').not('.ng-hide').css('margin-top', '-' + actualTopSize + 'px');
                    }
                });
            };

            $scope.resetHoverIndex = function() {
                $scope.hoveredIndex = -1; 
            };
                
            $scope.menuClicked = function(namee) {                                        
                $state.go(routes.getRouteByName(namee).state);
            };

            $scope.subMenuClicked = function(namee) {                 
                $state.go(routes.getRouteByName(namee).state);
            };

            $scope.$on('$destroy', function () {
                document.onmousemove =
                                document.onclick =
                                document.onkeydown = null;
                clearTimeout(idleTimeout);
            });
        }]);
})();